module.exports = {"220502001":"东昌街道","220502002":"民主街道","220502003":"老站街道","220502004":"团结街道","220502005":"新站街道","220502006":"光明街道","220502007":"龙泉街道","220502100":"金厂镇","220502120":"通化经济开发区（特殊乡镇）","220502200":"环通乡","220502201":"江东乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220502.json
// module id = 584
// module chunks = 0